import { store } from './store';
import * as action from './constants';

const ActionCreators = {};

ActionCreators.home = state => {
  store.dispatch({
    type: action.HOME,
    state
  });
};

ActionCreators.createNew = () => {
  store.dispatch({
    type: action.CREATE_NEW_GAZETTEER
  });
};

ActionCreators.createFromExisting = geojson => {
  store.dispatch({
    type: action.CREATE_FROM_EXISTING,
    geojson
  });
};

ActionCreators.setName = name => {
  store.dispatch({
    type: action.SET_NAME,
    name
  });
};

ActionCreators.setPlaceName = (id, placeName) => {
  store.dispatch({
    type: action.SET_PLACE_NAME,
    id,
    placeName
  });
};

ActionCreators.setPlaceDescription = (id, placeDescription) => {
  store.dispatch({
    type: action.SET_PLACE_DESCRIPTION,
    id,
    placeDescription
  });
};

ActionCreators.setPosition = id => {
  store.dispatch({
    type: action.SET_POSITION,
    id
  });
};

ActionCreators.setTags = (id, tags) => {
  store.dispatch({
    type: action.SET_TAGS,
    id,
    tags
  });
};

ActionCreators.setMeta = (id, meta) => {
  store.dispatch({
    type: action.SET_META,
    id,
    meta
  });
};

ActionCreators.setMapResult = (result, zoom) => {
  store.dispatch({
    type: action.SET_MAP_RESULT,
    result,
    zoom
  });
};

ActionCreators.addFeature = () => {
  store.dispatch({
    type: action.FEATURE_ADD
  });
};

ActionCreators.activeFeature = feature => {
  store.dispatch({
    type: action.FEATURE_ACTIVE,
    feature
  });
};

ActionCreators.deleteFeature = id => {
  store.dispatch({
    type: action.FEATURE_DELETE,
    id
  });
};

ActionCreators.updateFeatureIndex = ({ oldIndex, newIndex }) => {
  store.dispatch({
    type: action.FEATURE_UPDATE_INDEX,
    oldIndex,
    newIndex
  });
};

export { ActionCreators };
